import React, { useState } from "react";

import { useConversationState } from "../conversation-state-provider";
import { ChatOptionComponentProps } from "../lookup";
import { SelfAdjustingTextareaWithAttachments } from "~/components/input/self-adjusting-textarea-with-attachments";
import { cn } from "~/util/cn";

export const TextDrawer: React.FC<ChatOptionComponentProps> = ({
  sendResponse: onSendMessage,
}) => {
  const [message, setMessage] = useState("");
  const { isChatBusy } = useConversationState();

  return (
    <div
      className={cn(
        "w-full sm:mb-4",
        "bg-base-100 px-4 py-3",
        "border-x border-t border-neutral-200 sm:border-x sm:border-b",
        "rounded-t-2xl sm:rounded-b-2xl",
        "max-w-screen-sm",
      )}
    >
      <SelfAdjustingTextareaWithAttachments
        text={message}
        setText={setMessage}
        onSubmit={({ payload, onDone }) => {
          const base64Images = payload.attachments.map(
            (attachment) => attachment.base64,
          );

          const { hasResponseBeenSent } = onSendMessage({
            message: payload.text,
            base64Images,
            base64Audio: payload.base64Audio,
            selection: [],
          });
          if (hasResponseBeenSent) {
            onDone();
          }
        }}
        disableSubmit={isChatBusy}
      />
    </div>
  );
};
